<!-- <p>model-details works!</p> -->

<div class="main-model-div">
    <div class="top-div alignRow">
        @if (model && asset && selectedModelType) {
        <span style="font-size: large; font-weight: bolder;">
            Model: {{selectedModelType.ModelName}} on {{asset.Name}} - {{asset.Description}}
        </span>
        } @if (modelFoundStatus == 'notFound') {
        <span style="font-size: large; font-weight: bolder;">
            Unable to find requested Model
        </span>
        } @if (modelFoundStatus == '') {
        <span style="font-size: large;">
            Loading Model information
        </span>
        }
        <span class="toolbar-spacer"></span>
        <button mat-raised-button (click)="back()" style="margin: 0.25em; margin-bottom: 0.5em;" class="app-icon--back">
            <mat-icon />
            <span>Back</span>
        </button>
    </div>
    <div class="subtitle" *ngIf="model && model.CreatedByUserSub">
        <span>Model Created By: {{model.CreatedByUserSub}}</span>
        <span *ngIf="model.CreatedAt">&nbsp;on {{getDate(model.CreatedAt)}}</span>
    </div>
    <div class="button-div alignRow" *ngIf="model">
        <button mat-raised-button color="primary" (click)="viewModel()" [disabled]="!model || !asset">
            <span>View Model</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        <button mat-raised-button color="primary" (click)="goToAsset()" [disabled]="!model || !asset"
            class="app-icon--goto">
            <span>Go To Asset</span>
            <mat-icon />
        </button>
        <button *ngIf="model.MostRecent" mat-raised-button (click)="patchOldDistribution(model, false, false)"
            [disabled]="!model || !asset">
            <span>Deactivate Model</span>
            <mat-icon>close</mat-icon>
        </button>
        <button *ngIf="!model.MostRecent" mat-raised-button (click)="patchOldDistribution(model, true, false)"
            [disabled]="!model || !asset">
            <span>Activate Model</span>
            <mat-icon>check</mat-icon>
        </button>
        <button mat-raised-button (click)="patchOldDistribution(model, false, true)" [disabled]="!model || !asset">
            <span>Delete Model</span>
            <mat-icon style="color: salmon;">delete</mat-icon>
        </button>
        @if (CMMSCase && checkFeature(AccountFeatures.SAP)) {
        <button mat-raised-button style="margin-left: 0.5em;" color="primary" (click)="viewCMMS()">
            <span>view Case</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        }
        <span class="toolbar-spacer"></span>
        <button mat-raised-button style="margin: 0.25em; margin-bottom: 0.5em;" (click)="goToModels()">
            <mat-icon>auto_awesome</mat-icon>
            <span>All Models</span>
        </button>
    </div>
    <div *ngIf="model" class="model-details">
        <span>Model Type:</span>
        <span *ngIf="selectedModelType" style="font-weight: bold;">{{selectedModelType.ModelName}}</span>
        <span>Active:</span>
        <span style="font-weight: bold;">{{model.MostRecent ? 'Yes' : 'No'}}</span>
        <span>Type:</span>
        <span style="font-weight: bold;">{{model.IsAutomatic ? 'Automatic' : 'Manual'}}</span>
        <span></span>
        <span></span>
        <span>Tolerance:</span>
        <span style="font-weight: bold;">{{model.Tolerance}}</span>
        <span>Sensitivity:</span>
        <span style="font-weight: bold;">{{model.Sensitivity}}</span>
        <span>Start Point:</span>
        <span style="font-weight: bold;">{{getDate(model.StartPoint)}}</span>
        <span>End Point:</span>
        <span style="font-weight: bold;">{{getDate(model.EndPoint)}}</span>
    </div>
    <div class="listboxes" *ngIf="model">
        <div class="events-list-div">
            <div class="top-div">
                <span style="font-size: large; font-weight: bolder;">Event History</span>
            </div>
            <div class="deviation-events-list">
                <span>Timestamp</span>
                <span>DataPoint</span>
                <span>Tolerance</span>
                <span>Sensitivity</span>
                <span>Amount Deviated</span>
            </div>
            <ejs-listbox [dataSource]='filteredDeviationEvents' [fields]="deviationFields" class="listbox-container"
                [allowFiltering]="true" filterBarPlaceholder="Search for an Event" filterType="contains">
                <ng-template #itemTemplate let-data>
                    <div class="deviation-events-list ejs-listbox-item" (click)="goToEvent(data)">
                        <span style="font-weight: bolder;">{{ getDate(data.Timestamp) }}</span>
                        <span>{{ data.DPTitle }}</span>
                        <span>{{ data.AcceptableDeviation }}</span>
                        <span>{{ data.Sensitivity }}</span>
                        <span>{{ data.Sensitivity == 50 ? 'Majority' : data.PercentageDeviated + '%'}}</span>
                    </div>
                </ng-template>
            </ejs-listbox>
        </div>
        <div class="events-list-div">
            <div class="top-div">
                <span style="font-size: large; font-weight: bolder;">Edit History</span>
                <span class="toolbar-spacer"></span>
            </div>
            <div class="edit-history">
                <span>Previous Properties</span>
                <span>New Properties</span>
                <span>User</span>
                <span>Timestamp</span>
            </div>
            <ejs-listbox [dataSource]='modelEdits' [fields]="editFields" cssClass='e-list-template'
                class="listbox-container">
                <ng-template #itemTemplate let-dataSource>
                    <div class="ejs-listbox-item edit-history">
                        <span>{{dataSource.PreviousProperties}}</span>
                        <span>{{dataSource.NewProperties}}</span>
                        <span>{{dataSource.UserSub}}</span>
                        <span style="font-weight: bolder;">{{ getDate(dataSource.Timestamp) }}</span>
                    </div>
                </ng-template>
            </ejs-listbox>
        </div>
    </div>
</div>